import { Box, Typography } from "@mui/material";
import ConversationsStore from "components/Conversations/Stores/ConversationsStore";
import React from "react";
import theme from "Theme/AppTheme";

interface SummarySectionProps {
    store: ConversationsStore;
}

const SummarySection: React.FC<SummarySectionProps> = ({ store }) => {
    return (
        <Box sx={{ width: "85%" }}>
            <Typography
                fontWeight={600}
                fontSize={"14px"}
                marginBottom={theme.spacing(1)}
                sx={
                    {
                        // summaryTitle hover effect (canCollapse is not used in this file, so omitting hover logic)
                        // If you need hover effect based on a prop, use a styled component and pass the prop
                    }
                }
            >
                {`${
                    store.selectedConversation?.isChat ? "Chat " : "Call "
                }Summary`}
            </Typography>
            {store.selectedConversation &&
                (store.selectedConversation.summary ?? "No Summary")}
        </Box>
    );
};

export default SummarySection;
